import { useMutation } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { GymListingService } from "../../services/gymListing.service";

export const useGymsMutations = () => {
  const { mutate: notificationForComingSoonGym } = useMutation<any, Error, string>({
    mutationKey: [QUERY_CONSTANTS.NOTIFICATION_FOR_COMING_SOON_GYM],
    mutationFn: async (gymListingId: string) =>
      GymListingService.notificationForComingSoonGym(gymListingId).then((res) => res.data),
  });

  return {
    notificationForComingSoonGym,
  };
};
